import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FiltersService } from '../../services';

@Component({
  selector: 'app-related-equipments',
  templateUrl: './related-equipments.component.html',
  styleUrls: ['./related-equipments.component.scss']
})
export class RelatedEquipmentsComponent implements OnInit {
  equipmentsArr = [];
  areasArr = [];

  @Output() relateds = new EventEmitter();

  @Input() relatedEquipments;

  @Input() isEdit: boolean;

  constructor( private filtersService: FiltersService ) { }

  ngOnInit() {
    this.filtersService.listEquipments().subscribe((response) => {
      this.equipmentsArr = response['data'];
    });

    this.filtersService.listAreas().subscribe((response) => {
      this.areasArr = response['data'];
    })
  }

  removeEquipment(index) {
    this.relatedEquipments.splice(index, 1);
  }

  addEquipment() {
    this.relatedEquipments.push({
      cdArea: "",
      cdProduto: "",
      vlMaxManutencao: 0,
      vlMaxMaterial: 0
    });
  }

  outputEquipments() {
    this.relateds.emit(this.relatedEquipments);
  }

}
